import React from "react";

const SatisfactionSurveyBanner = () => {
  const surveyUrl =
    "https://forms.penalolen.cl/consulta-de-satisfaccion-de-usuarios";

  const openSurvey = () => {
    window.open(surveyUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="card border-0 bg-light-primary overflow-hidden mb-7 mt-3">
      <div className="card-body position-relative py-8 px-6 px-lg-10">
        {/* Decoración de fondo */}
        <div
          className="position-absolute rounded-circle bg-primary opacity-10"
          style={{
            width: "220px",
            height: "220px",
            top: "-120px",
            right: "-60px",
          }}
        />

        <div
          className="position-absolute rounded-circle bg-primary opacity-10"
          style={{
            width: "110px",
            height: "110px",
            bottom: "-65px",
            right: "150px",
          }}
        />

        <div className="row align-items-center position-relative">
          <div className="col-12 col-lg-auto mb-5 mb-lg-0">
            <div className="symbol symbol-70px">
              <div className="symbol-label bg-primary">
                <i className="ki-duotone ki-message-question fs-2x text-white">
                  <span className="path1" />
                  <span className="path2" />
                  <span className="path3" />
                </i>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg">
            <span className="badge badge-light-primary fw-bold mb-3">
              Tu opinión es importante
            </span>

            <h2 className="fs-2 fw-bold text-gray-900 mb-2">
              Ayúdanos a mejorar nuestros servicios
            </h2>

            <p className="fs-6 text-gray-700 mb-0 mw-700px">
              Te invitamos a responder una breve encuesta de satisfacción.
              Tus comentarios nos permitirán conocer tu experiencia y seguir
              mejorando la atención entregada.
            </p>
          </div>

          <div className="col-12 col-lg-auto mt-6 mt-lg-0">
            <button
              type="button"
              className="btn btn-primary btn-lg fw-bold d-flex align-items-center justify-content-center w-100"
              onClick={openSurvey}
            >
              Responder encuesta

              <i className="ki-duotone ki-arrow-right fs-3 ms-2">
                <span className="path1" />
                <span className="path2" />
              </i>
            </button>

            <div className="text-center text-lg-end text-muted fs-8 mt-2">
              Solo te tomará unos minutos
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SatisfactionSurveyBanner;